var chunkMapping = {
	"70": [
		3070
	],
	"512": [
		1596,
		3021,
		5368,
		5786,
		6851,
		7071,
		8089,
		9068,
		9166
	],
	"636": [
		330,
		421,
		5271,
		7343,
		6435,
		5711,
		5534
	]
};
var idToExternalAndNameMapping = {
	"330": [
		"default",
		"./generic/components/general/toast",
		1305
	],
	"421": [
		"default",
		"./generic/helpers/google-tag-manager",
		1305
	],
	"1596": [
		"default",
		"./generic/components/cards/card-news",
		1305
	],
	"3021": [
		"default",
		"./generic/components/cards/card-mdc",
		1305
	],
	"3070": [
		"default",
		"./generic/components/general/sheet",
		1305
	],
	"5271": [
		"default",
		"./generic/elements/icons",
		1305
	],
	"5368": [
		"default",
		"./generic/components/cards/card-fixture",
		1305
	],
	"5534": [
		"default",
		"./generic/elements/menu-item",
		1305
	],
	"5711": [
		"default",
		"./generic/elements/info-block",
		1305
	],
	"5786": [
		"default",
		"./mancity/components/general/seo",
		1305
	],
	"6435": [
		"default",
		"./generic/components/profile/avatar",
		1305
	],
	"6851": [
		"default",
		"./generic/components/general/carousel-indicator",
		1305
	],
	"7071": [
		"default",
		"./generic/components/cards/card-featured",
		1305
	],
	"7343": [
		"default",
		"./generic/elements/button",
		1305
	],
	"8089": [
		"default",
		"./generic/components/general/loading-skeleton",
		1305
	],
	"9068": [
		"default",
		"./generic/elements/countdown",
		1305
	],
	"9166": [
		"default",
		"./generic/elements/divider",
		1305
	]
};
var idToRemoteMap = {
	"330": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"421": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"1596": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"3021": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"3070": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5271": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5368": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5534": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5711": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5786": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"6435": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"6851": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"7071": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"7343": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"8089": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"9068": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"9166": [
		{
			"externalType": "script",
			"name": "core"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"330": {
		"shareScope": "default",
		"name": "./generic/components/general/toast",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"421": {
		"shareScope": "default",
		"name": "./generic/helpers/google-tag-manager",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"1596": {
		"shareScope": "default",
		"name": "./generic/components/cards/card-news",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"3021": {
		"shareScope": "default",
		"name": "./generic/components/cards/card-mdc",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"3070": {
		"shareScope": "default",
		"name": "./generic/components/general/sheet",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"5271": {
		"shareScope": "default",
		"name": "./generic/elements/icons",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"5368": {
		"shareScope": "default",
		"name": "./generic/components/cards/card-fixture",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"5534": {
		"shareScope": "default",
		"name": "./generic/elements/menu-item",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"5711": {
		"shareScope": "default",
		"name": "./generic/elements/info-block",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"5786": {
		"shareScope": "default",
		"name": "./mancity/components/general/seo",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"6435": {
		"shareScope": "default",
		"name": "./generic/components/profile/avatar",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"6851": {
		"shareScope": "default",
		"name": "./generic/components/general/carousel-indicator",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"7071": {
		"shareScope": "default",
		"name": "./generic/components/cards/card-featured",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"7343": {
		"shareScope": "default",
		"name": "./generic/elements/button",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"8089": {
		"shareScope": "default",
		"name": "./generic/components/general/loading-skeleton",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"9068": {
		"shareScope": "default",
		"name": "./generic/elements/countdown",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"9166": {
		"shareScope": "default",
		"name": "./generic/elements/divider",
		"externalModuleId": 1305,
		"remoteName": "core"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}